import { render, staticRenderFns } from "./RegistrationsOverTimeSection.vue?vue&type=template&id=1fdd6613&scoped=true&"
import script from "./RegistrationsOverTimeSection.vue?vue&type=script&lang=js&"
export * from "./RegistrationsOverTimeSection.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationsOverTimeSection.vue?vue&type=style&index=0&id=1fdd6613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd6613",
  null
  
)

export default component.exports